document.addEventListener('DOMContentLoaded', function () {
    let loadMoreButton = document.getElementById('load-more');
    if (loadMoreButton) {
        loadMoreButton.addEventListener('click', function () {
            let page = parseInt(loadMoreButton.getAttribute('data-page'));
            let ajaxUrl = loadMoreButton.getAttribute('data-url');

            let xhr = new XMLHttpRequest();
            xhr.open('POST', ajaxUrl, true);
            xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
            xhr.onload = function () {
                if (xhr.status >= 200 && xhr.status < 400) {
                    let response = JSON.parse(xhr.responseText);

                    if (response.success) {

                        document.getElementById('post-container').insertAdjacentHTML('beforeend', response.data.html);

                        page++;
                        loadMoreButton.setAttribute('data-page', page);

                        console.log('Has more posts:', response.data.has_more_posts);

                        if (!response.data.has_more_posts) {
                            loadMoreButton.style.display = 'none';
                        }
                    } else {
                        console.error('Något gick fel med förfrågan.');
                    }
                } else {
                    console.error('Något gick fel med förfrågan.');
                }
            };
            xhr.send('action=load_more_posts&page=' + page);
        });
    }
});